import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ICompanyExtendedInfo } from 'src/app/interface/dto';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { CompanyService } from '../services/company-service.service';
import { AuthService } from '../services/http-services/authservice.service';

@Component({
  selector: 'app-company-settings',
  templateUrl: './company-settings.component.html',
  styleUrls: ['./company-settings.component.scss']
})
export class CompanySettingsComponent implements OnInit, AfterViewInit {
  text = 'Edit'
  companyInfo: ICompanyExtendedInfo;
  modelError = ""
  mode = "";
  disableAll = false;
  logoPix: File;
  constructor(private companyService: CompanyService, private snackBar: SnackbarService, private actRoute: ActivatedRoute, private authService: AuthService) { }

  async ngOnInit() {
    // Get company extended info from DB
    let company = this.authService.user.company;
    if (!company)
      this.snackBar.error("Company not found")
    this.companyInfo = await this.companyService.getCompanyExtendedInfo(company) as ICompanyExtendedInfo;

    console.log("Company Info", this.companyInfo)
  }

  ngAfterViewInit() {
    const tabButtons = document.querySelectorAll('.nav-link');

    tabButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        tabButtons.forEach(b => b.classList.remove('bg-success', 'text-white'));
        btn.classList.add('bg-success', 'text-white');
      });
    });

    // this.logoPix.nativeElement.src = this.companyInfo.logoURL;

  }

  // ngAfterViewChecked() {
  //   const tabButtons = document.querySelectorAll('.nav-link');

  //   tabButtons.forEach(btn => {
  //     btn.addEventListener('click', () => {
  //       tabButtons.forEach(b => b.classList.remove('bg-success', 'text-white'));
  //       btn.classList.add('bg-success', 'text-white');
  //     });
  //   });
  // }
  async saveCompanyInfo() {
    this.validateModel();
    if (this.modelError == '') {
      // Save company info to DB
      await this.companyService.updateInstructions(this.companyInfo);
      this.snackBar.success("Company info updated successfully");
    }
  }

  validateModel() {
    this.modelError = '';
    // if (this.companyInfo.company == '') {
    //   this.modelError += "*Company ID missing\n"
    // }
    // if (this.companyInfo.instructionsHTML == '') {
    //   this.modelError += "\n*Instructions required\n"
    // } 
  }

  onEditClicked() {
    this.disableAll = false;
    this.text = 'Update'
  }

  steps: string[] = [
    'Company Instructions',
    'Question Settings',
    // 'Security',
    // 'Proctoring',
    // 'Instructions',
    // 'Others'
  ];
  uploadLogo() {
    if (this.logoPix) {
      const formData = new FormData();
      formData.append('file', this.logoPix);
      this.companyService.uploadLogo(formData).then((response: any) => {
        this.snackBar.success("Logo uploaded successfully");
        this.companyInfo.logoURL = response.logoURL; // Update the logo URL in the model
      }).catch(error => {
        console.log(error);
        this.snackBar.error("Failed to upload logo");
      });
    }
  }

  onFileChange(event: any) {
    if (event.target.files && event.target.files[0]) {
      this.logoPix = event.target.files[0];;
    }
  }
  // currentStep: number = 0;

  // nextStep() {
  //   if (this.currentStep < this.steps.length - 1) this.currentStep++;
  // }

  // prevStep() {
  //   if (this.currentStep > 0) this.currentStep--;
  // }
  // nextTab(currentIndex) {
  //   const nextTabTrigger = document.querySelector(`#tab${currentIndex + 1}`) as HTMLElement;
  //   if (nextTabTrigger) nextTabTrigger.click();
  // }

  // prevTab(currentIndex) {
  //   const prevTabTrigger = document.querySelector(`#tab${currentIndex - 1}`) as HTMLElement;
  //   if (prevTabTrigger) prevTabTrigger.click();
  // }

}
